import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import { useMerchant } from "@/hooks/useMerchant";
import { useProtectTRPC } from "../trpc";
import { ContractFilters } from "./types";

export function useFetchContracts(filters: ContractFilters, cursor?: string) {
  const { merchant } = useMerchant();
  const trpc = useProtectTRPC();

  const queryInput = useMemo(
    () => ({
      rentalsMerchantId: merchant?.id ?? "",
      tenantDocumentNumber: filters.tenantDocumentNumber?.trim() || undefined,
      status: filters.status,
      cursor,
    }),
    [merchant?.id, filters, cursor]
  );

  const { data, isPending } = useQuery({
    ...trpc.contracts.list.queryOptions(queryInput),
    enabled: !!merchant?.id,
  });

  return {
    contracts: data?.contracts ?? [],
    nextCursor: data?.cursor || undefined,
    isLoading: isPending,
  };
}
